<template>
  <div class="introduction-content5">
    <div class="title-container">
      <div class="title-text">公司愿景</div>
      <div class="title-text-en">Corporate Vision</div>
    </div>
    <div class="content-container">
      {{ content }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntroductionContent5',
  data() {
    return {
      content: '利用互联网技术为客户提供更加优质的产品和服务，给客户的活动现场带来更多的花样、乐趣和激情。',
    };
  },
};
</script>

<style lang="less" scoped>
.introduction-content5 {
  width: 100%;
  height: auto;
  margin-top: 90px;
  
  .title-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    
    .title-text {
      font-weight: 700;
      font-size: 32px;
      line-height: 1;
      background: linear-gradient(to bottom, #CA5EFB 46%, #844DFE 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
    
    .title-text-en {
      font-weight: 500;
      font-size: 18px;
      line-height: 1.5;
      background: linear-gradient(to bottom, #CA5EFB 46%, #844DFE 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      margin-top: 12px;
    }
  }
  
  .content-container {
    width: 1150px;
    background: linear-gradient(270deg, rgba(102,27,135,0.5) 0%, rgba(20,79,139,0.5) 100%);
    border-radius: 12px;
    padding: 47px 60px;
    margin: 48px auto 0;
    font-weight: 500;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 30px;
    text-align: justify;
  }
}
</style>
